'use client';

import { SectionHeading } from "@/components/taller/section-heading";
import { useTranslations } from "@/i18n/client";
import { Reveal } from "@/components/ui/reveal";

const ICONS = [
  <svg key="1" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>,
  <svg key="2" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z"/></svg>,
  <svg key="3" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/><line x1="6" y1="20" x2="6" y2="16"/></svg>,
];

/** Modern Valor section with dark cards and accent icons. */
export function Valor() {
  const { t, isLoading } = useTranslations();
  const valor = t('valor');

  if (isLoading) return null;

  const cards = valor.cards ?? [
    { title: 'Confianza al primer clic', body: 'Diseño a medida y adaptado a móvil que valida tu autoridad y marca.' },
    { title: 'Negocio en piloto automático', body: 'Citas, formularios y automatizaciones que liberan tu agenda diaria.' },
    { title: 'Conquista Google', body: 'Arquitectura SEO pensada para captar clientes cualificados desde el inicio.' },
  ];

  return (
    <section className="py-24 md:py-32">
      <div className="max-w-[var(--container-max)] mx-auto px-6 md:px-14">
        <SectionHeading
          overline={valor.overline || 'Cómo te ayuda'}
          heading={
            <>
              {valor.heading || 'Una web que '}
              <em>{valor.headingAccent || 'trabaja por ti.'}</em>
            </>
          }
          className="mb-20"
        />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {cards.map((card, i) => (
            <Reveal key={card.title} delay={i * 0.1} width="100%">
              <div className="bg-[var(--color-surface)] p-6 md:p-10 rounded-[var(--radius-lg)] border border-[var(--color-border)] h-full transition-all duration-300 hover:border-[var(--color-border-hover)] hover:shadow-[var(--shadow-glow-card)] group">
                <div className="text-[var(--color-accent)] mb-8 transition-transform duration-300 group-hover:scale-110">
                  {ICONS[i]}
                </div>
                <div className="font-sans font-semibold text-[18px] text-[var(--color-ink)] mt-6 tracking-tight">
                  {card.title}
                </div>
                <p className="font-sans text-[14px] leading-[1.6] text-[var(--color-mute)] mt-3 mb-0">
                  {card.body}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
